import Env from "../base/env.js";
import Channels from "../base/channels.js";
import Launcher from "../view/launcher";
import UISwitcher from "../ui/UISwitcher";
import SmoothieLenis from "../fx/SmoothieLenis";
import gsap from "gsap";

class UI {
  constructor() {
    if (typeof history.scrollRestoration != "undefined") {
      history.scrollRestoration = "manual";
    }
    this.launcher = new Launcher();
    this.detectAppHeight();
    this.resetEnv();
    this.uiSwitch = new UISwitcher();

    // Smooth
    gsap.delayedCall(0.3, () => {
      this.smoothie = new SmoothieLenis();
      this.smoothie.setup();
    });
  }

  appHeight() {
    const doc = document.documentElement;
    doc.style.setProperty("--app-height", `${window.innerHeight}px`);
  }

  detectAppHeight() {
    this.appHeight();
    Channels.on("window::smartresize", this.appHeight);
  }

  resetEnv() {
    Channels.on("statechange::before", function () {
      Env.$html.classList.remove("mainnav--isOpened");
      Env.$html.classList.remove("subnav--isOpened");
    });
    Channels.on("statechange::ready", (current, old, container) => {
      Env.isVisiting = true;
      // Env.$html.classList.remove('skin--isWhite')
      // Env.$html.classList.remove('skin--isDark')
      // Env.$mainNav.classList.remove('is--active');
      // Env.$html.classList.remove('mainnav--isOpened')
      if (Env.isVisiting === true) {
        if (typeof Env.framework.UI.smoothie != "undefined") {
          // Env.framework.UI.smoothie.setup();
        }
      }
    });
    Channels.on("statechange::finalize", () => {});
  }
}

export default UI;
